import * as Yup from 'yup';
import {FileUploaded} from '~/lib/file';
import {ID} from '~/lib/model';

type IPaymentTaxFile = FileUploaded;

export interface IPaymentDetails {
    sellerId: ID;
    taxFrom: IPaymentTaxFile;
    beneficiaryName: string;
    beneficiaryCountry: string;
    beneficiaryState: string;
    beneficiaryCity: string;
    beneficiaryStreetAddress1: string;
    beneficiaryStreetAddress2: string;
    beneficiaryZipCode: string;
    beneficiaryPhoneNumber: string;
    bankCountry: string;
    bankName: string;
    beneficiaryAccountName: string;
    bankAccountNumber: string;
    bankSWIFTCode: string;
    intermediaryBankName: string;
    intermediaryBankAccountNumber: string;
    intermediaryBankSWIFTCode: string;
}

export const PaymentDetailsSchema = Yup.object().shape<IPaymentDetails>({
    sellerId: null,
    bankAccountNumber: Yup.string().required(),
    bankCountry: Yup.string().nullable().required(),
    bankName: null,
    bankSWIFTCode: Yup.string().required(),
    beneficiaryAccountName: null,
    beneficiaryCity: Yup.string().required(),
    beneficiaryCountry: Yup.string().required(),
    beneficiaryName: Yup.string().required(),
    beneficiaryPhoneNumber: null,
    beneficiaryState: null,
    beneficiaryStreetAddress1: Yup.string().required(),
    beneficiaryStreetAddress2: null,
    beneficiaryZipCode: Yup.string().required(),
    intermediaryBankAccountNumber: null,
    intermediaryBankName: null,
    intermediaryBankSWIFTCode: null,
    taxFrom: null
});
